import GuestGuard from "../Shared-ui/utils/Routes/GuestGuard"
import MinimalLayout from "../Shared-ui/Layout/MinimalLayout"
import Login from "../Views/Pages/Login";
import Register from "../Views/Pages/Register"
import AuthGuard from "../Shared-ui/utils/Routes/AuthGuard";
import PasswordReset from "../Views/Pages/ForgotPassword";
import GetStarted from "../Views/Pages/GetStarted";
import MicrosoftCallback from "../Views/Pages/MicrosoftCallback";

const UnAutherizedRoutes = {

    element: (
        <GuestGuard>
            <MinimalLayout />
        </GuestGuard>),
    children: [
        {
            path:'/',
            // element:<GetStarted/>
            element:<Login/>
        },
        {
            path: '/login',
            element: <Login />
        },
        {
            path: '/register',
            element: <Register />
        },
        {
            path: '/forgot',
            element: <PasswordReset />
        },
        {
            path: '/getstarted',
            element: <PasswordReset />
        },
        {
            path: '/auth/microsoft/callback',
            element: <MicrosoftCallback />
        },
        

    ]

}


export default UnAutherizedRoutes